var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container"},[_c('p',[_vm._v(" Made by "),_c('a',{attrs:{"href":"https://github.com/mrblot","target":"_blank"}},[_c('v-icon',{attrs:{"name":"github"}}),_vm._v("mrblot")],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }